@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) '../../../../../../constants/z-index.module.less';

.wizard-step {
  border: 1px solid var(--default--border-color--10);
  border-radius: 4px;
  margin-bottom: @space-12;
  background: var(--light--background-color--1);
  overflow: hidden;
}

.wizard-step-header {
  padding: @space-12 @space-16;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.wizard-step-header-left {
  align-items: center;
  gap: @space-12;
  flex: 1;
  min-width: 0;
}

.step-badge-active {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--brand--primary--color);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 12px;
}

.step-badge-done {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--status--success--color);
  font-size: 18px;
}

.step-badge-pending {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid var(--default--border-color--10);
  color: var(--default--text-color--9);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 12px;
}

.step-content {
  padding: @space-4 @space-16 @space-16;
  border-top: 1px solid var(--default--border-color--10);
}

.step-collapsed-summary {
  padding: @space-4 @space-16 @space-12;
  color: var(--default--text-color--9);
  border-top: 1px solid var(--default--border-color--10);
}
